import i from 'i18next'

import HeaderPages from '~/components/HeaderPages'

import RequestTesterContent from './components/RequestTesterContent'
import { RequestAdsProvider } from './hooks/useRequestAds'

const RequestTesterPage: React.FC = () => (
  <>
    <HeaderPages title={i.t('rm:Tools.AdRequest.pageTitle')} />

    <RequestAdsProvider>
      <RequestTesterContent />
    </RequestAdsProvider>
  </>
)

export default RequestTesterPage
